<template>
    <RoleForm :role="role" :menus="menus" />
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import RoleForm from "./Form.vue";

export default {
    name: "RoleEdit",
    layout: AppLayout,
    components: {
        RoleForm,
    },
    props: {
        role: {
            type: Object,
            required: true,
        },
        menus: {
            type: Array,
            default: () => [],
        },
    },
}
</script>

